export const openPopup = (url?: string, target: string = '', features: string = "height=700,width=900") => {
    if (!url) {
        console.warn('Popup url is required');
        return;
    }

    window.open(url, target, features);
}